/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Flyerbackgroundpreset2Inputs */

const en_flyerbackgroundpreset2 = /** @type {(inputs: Flyerbackgroundpreset2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Background color ${i?.number}`)
};

const de_flyerbackgroundpreset2 = /** @type {(inputs: Flyerbackgroundpreset2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hintergrundfarbe ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Background color {number}" |
*
* @param {Flyerbackgroundpreset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerbackgroundpreset2 = /** @type {((inputs: Flyerbackgroundpreset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerbackgroundpreset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerbackgroundpreset2(inputs)
	return de_flyerbackgroundpreset2(inputs)
});
export { flyerbackgroundpreset2 as "flyerBackgroundPreset" }